import {forwardRef} from 'react';

import {SizeTokenValue} from 'common';

import {SVG} from './SVG';

import type {IconComponent} from 'icons/types';

const largeIcon = [
  <path
    key="0"
    d="M13 6.4125L14.88 8.2925C15.27 8.6825 15.9 8.6825 16.29 8.2925C16.68 7.9025 16.68 7.2725 16.29 6.8825L12.7 3.2925C12.31 2.9025 11.68 2.9025 11.29 3.2925L7.7 6.8825C7.31 7.2725 7.31 7.9025 7.7 8.2925C8.09 8.6825 8.72 8.6825 9.11 8.2925L11 6.4125V16.0825C11 16.6325 11.45 17.0825 12 17.0825C12.55 17.0825 13 16.6325 13 16.0825V6.4125Z"
  />,
  <path
    key="1"
    d="M3 20C3 19.4477 3.44772 19 4 19H20C20.5523 19 21 19.4477 21 20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20Z"
  />,
];

const smallIcon = [
  <path
    key="0"
    fillRule="evenodd"
    clipRule="evenodd"
    d="M8.06506 10.435C8.06506 10.747 7.8121 11 7.50006 11C7.18802 11 6.93506 10.747 6.93506 10.435V3.86409L4.89957 5.89957C4.67893 6.12022 4.32119 6.12022 4.10054 5.89957C3.87989 5.67893 3.87989 5.32119 4.10054 5.10054L7.10054 2.10054C7.2065 1.99459 7.35021 1.93506 7.50006 1.93506C7.6499 1.93506 7.79361 1.99459 7.89957 2.10054L10.8996 5.10054C11.1202 5.32119 11.1202 5.67893 10.8996 5.89957C10.6789 6.12022 10.3212 6.12022 10.1005 5.89957L8.06506 3.86409V10.435Z"
  />,
  <path
    key="1"
    fillRule="evenodd"
    clipRule="evenodd"
    d="M1.935 13.5C1.935 13.188 2.18796 12.935 2.5 12.935H12.5C12.812 12.935 13.065 13.188 13.065 13.5C13.065 13.812 12.812 14.065 12.5 14.065H2.5C2.18796 14.065 1.935 13.812 1.935 13.5Z"
  />,
];

export const ExportIcon: IconComponent = forwardRef((props, ref) => {
  const {size} = props;

  return (
    <SVG ref={ref} name="Export" {...props}>
      {!size || size === SizeTokenValue.Large || size === SizeTokenValue.Medium ? largeIcon : smallIcon}
    </SVG>
  );
});
